var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comps-cardf-item",on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{ref:"backimg",staticClass:"icon centerimage",style:('background-image: url(' + _vm.imgurl + ')')}),_vm._v(" "),_c('p',{staticClass:"title to-2"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b1cbbb2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Models/comps/cardAreasB.vue
// module id = null
// module chunks = 